import { Product } from '../enums/booking';
import { ActorType, SourceType, WidgetType } from '../enums/conversation';
import { TaraLaunchSource } from '../enums/event';

export const ACTOR_INFO = {
    [ActorType.BOT]: {
        name: 'TARA',
    },
};

export const DSAT_TAG = {
    [Product.BUS]: 'bus_user_dsat',
    [Product.FLIGHT]: 'flight_user_dsat',
    [Product.HOTEL]: 'hotel_user_dsat',
    [Product.TRAIN]: 'train_user_dsat',
};

export const LOADING_TEXT = `Connecting with ${ACTOR_INFO[ActorType.BOT].name}...`;

export const MESSAGE_TEXT = {
    [SourceType.TICKET]: 'I want to know the status of my ticket - {{ticketId}}',
    [WidgetType.REFUND_TIMELINE]: 'I have not received my refund',
    [TaraLaunchSource.QUESTION]: 'I need help with my booking {{bookingId}}',
};

export const SUPPORT_TICKET_TAG = {
    [Product.BUS]: 'bus_freshdesk_ticket',
    [Product.FLIGHT]: 'flight_freshdesk_ticket',
    [Product.HOTEL]: 'hotel_freshdesk_ticket',
    [Product.TRAIN]: 'train_freshdesk_ticket',
};

export const UPLOAD_FILE_TAG = {
    [Product.BUS]: 'bus_upload_file',
    [Product.FLIGHT]: 'flight_upload_file',
    [Product.HOTEL]: 'hotel_upload_file',
    [Product.TRAIN]: 'train_upload_file',
};

export const LIP_SYNC_EMAILS = new Set([
    'akritisharma0095@gmail.com',
    'bhupesh.pruthi@gmail.com',
    'ekagra.midha@gmail.com',
    'ekagra.midha@travenues.com',
    'kinshuk.gupta@travenues.com',
    'lokesh.pathak@travenues.com',
    'raj.swarnim@travenues.com',
    'roxinswarnim@gmail.com',
    'shubhamcseiitkgp@gmail.com',
    'surajkrdubey@gmail.com',
    'upendra@travenues.com',
    'vaibhavagarwal123@gmail.com',
    'vivek@travenues.com',
    'yogeshchhabra729@gmail.com',
]);
